import { render, staticRenderFns } from "./InputFilter.vue?vue&type=template&id=28820324&scoped=true&"
import script from "./InputFilter.vue?vue&type=script&lang=js&"
export * from "./InputFilter.vue?vue&type=script&lang=js&"
import style0 from "./InputFilter.vue?vue&type=style&index=0&id=28820324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28820324",
  null
  
)

export default component.exports